module.exports = __webpack_public_path__ + "img/treatment-process.57234ebe.png";